import * as React from 'react'
import { ResourcesAdjustmentShape } from '../../api/api_data_types'
import EntryItem from './EntryItem'
import {
  edit_resources_adjustment_path,
  export_to_nav_resources_adjustment_path,
} from '../../routes'
import ExportToNavButton from './ExportToNavButton'
import EntryActions from './EntryActions'

type AdjustmentItemProps = {
  adjustment: ResourcesAdjustmentShape
}

export default function AdjustmentItem({ adjustment }: AdjustmentItemProps) {
  const isExported = adjustment.exported === true
  const canExport = adjustment.can_export_to_nav === true

  return (
    <EntryItem
      jobTitle={adjustment.jobnumber ? `${adjustment.jobnumber.order_number_title}. ${adjustment.jobnumber.customer_title}` : ''}
      times={adjustment.times}
      footer={
        <>
          {!isExported && (
            <EntryActions
              actions={[
                <a className="btn btn-outline-secondary mr-2" href={edit_resources_adjustment_path(adjustment.id)}>
                  Ændre
                </a>,
                canExport ? (
                  <ExportToNavButton href={export_to_nav_resources_adjustment_path(adjustment.id)} />
                ) : null,
              ].filter(Boolean) as React.ReactNode[]}
            />
          )}
        </>
      }
    />
  )
}

